import React, { Component } from 'react';
import Apihelpers from './helper/ApiHelper';
import { DateRangePicker, Dropdown, Alert } from 'rsuite';
import { NavLink } from 'react-router-dom';
import $ from 'jquery';
import { Textbox, } from 'react-inputs-validation';
const moment = require('moment-timezone');
const FileDownload = require('js-file-download');

class ApiHistoryExcel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      apihistoryexcelDownloadData: [],
      isloading: true,
    };
  }

  loadApiHistoryexcelDownloadData() {
    Apihelpers.getdataresponse('getapihistoryexcellist').then(res => {
      if (res.data.status === true) {
        this.setState({
          apihistoryexcelDownloadData: res.data.data,
          isloading: false,
        });
      } else {
        this.setState({
          apihistoryexcelDownloadData: res.data.data,
          isloading: false,
        });
      }
    });
  }

  toggleValidating(validate) {
    this.setState({ validate });
  }

  SubmitBulkRcUploadForm = e => {
    e.preventDefault();
    this.toggleValidating(true);
    if (!this.state.hasbulkRcfileError && this.state.bulkRcfile !== '') {
      const PostData = new FormData();
      PostData.append('reg_detail_csv', this.state.bulkRcfile);
      this.setState({
        isbulkUploading: true,
      });
      console.log('post data', PostData);
      Apihelpers.postdataresponseInternal(
        'bbuser/api_history_detail_excel',
        this.state.activeToken,
        PostData,
      )
        .then(res => {
          console.log('api response', res);
          this.setState({
            isbulkUploading: false,
          });
          if (res.data.status === true) {
            this.setState({
              isResponseDone: true,
              outputFilePath: res.data.outputFile,
              bulkRcfile: '',
              hasbulkRcfileError: true,
            });

            this.hideBulkUploadPopUpModel();
            Alert.success(
              'Successfully Upload Please Wait some time to Download Output file',
              6000,
            );

            setTimeout(() => {
              window.location.reload(1);
            }, 2500);
          } else {
            Alert.error(res.data.message, 5000);
            setTimeout(() => {
              window.location.reload(1);
            }, 3000);
          }
        })
        .catch(err => {
          console.log('errorr--------', err);
        });
    }
  };

  showBulkUploadPopUpModel = () => {
    $('#bulkRcuploadPopUp').show();
  };

  hideBulkUploadPopUpModel = () => {
    $('#bulkRcuploadPopUp').hide();
    this.setState({
      bulkRcfile: '',
      hasbulkRcfileError: true,
    });
  };

  render() {
    const { beforeToday } = DateRangePicker;
    return (
      <React.Fragment>
        <div className="wrapper">
          <header className="header">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-auto" style={{ width: '93%' }}>
                  <div className="logo">
                    <a>
                      <img src="/assets/images/logo.png" alt="" />
                    </a>
                  </div>
                </div>
                <div style={{ float: 'right' }}>
                  <NavLink
                    className="blueBtn btn-sm"
                    to={'/admin/logout'}
                    exact
                    activeClassName="active"
                    style={{ padding: ' 5px 10px', fontSize: '12px' }}
                  >
                    {' '}
                    LOGOUT
                  </NavLink>
                </div>
              </div>
            </div>
          </header>

          <div className="container">
           <div className="whiteBox reportPage">
            <br/>
             <div className="titleRow">
                <div className="row">
                  <div className="col">
                    <h3 className="title">API Hit History Excel</h3>
                  </div>
                  <div className="col-auto">
                    <NavLink to={"/admin/dashboard"} className="backLink"><i className="fa fa-arrow-left"></i> Back</NavLink>
                  </div>
                </div>
              </div>
             <div className="container">
             <div className="row">
              <div className="col">
                <div align="center">
                  <br />
                  <div className="note-text">
                    {' '}
                    Sheet in .xls or .xlsx format.
                  </div>
                  <br/>
                  <button
                    style={{ fontSize: 13 }}
                    className="blueBtn btn-sm"
                    onClick={this.showBulkUploadPopUpModel}
                  >
                    Bulk Api History Upload
                  </button>
                  <div>
                    {' '}
                    <br />{' '}
                    <a href="/assets/images/demo_file.xlsx" download>
                      Download Sample File
                    </a>
                  </div>
                  <br />
                  <div align="center">
                    <NavLink
                      className="yellowBtn"
                      to={'/admin/rcexcelList/5fed7790648ae566a563014c'}
                      exact
                      target="_blank"
                      activeClassName="active"
                      style={{ padding: ' 5px 10px', fontSize: '12px' }}
                    >
                      {' '}
                      Show API-History-Excel Detail
                    </NavLink>
                  </div>
                </div>
              </div>
             </div>
            </div>
            </div>
          </div>

          <div className="customPopup" id="bulkRcuploadPopUp">
            <div className="bgLayer" />
            <div className="popUpBox">
              <span
                className="closeIcon"
                onClick={() => this.hideBulkUploadPopUpModel()}
              >
                {' '}
              </span>
              <div className="popScroll" style={{ maxHeight: '94vh' }}>
                <div className="popUpHed">
                  <h3>Bulk ApiHistory Upload</h3>
                </div>
                <form
                  className="form"
                  method="post"
                  name="bulkRcFileUploadForm"
                  id="bulkRcFileUploadForm"
                  encType="multipart/form-data"
                  onSubmit={this.SubmitBulkRcUploadForm}
                >
                  <div className="form-group">
                    <label className="form-title">Upload File</label>
                    <div className="inputGroup">
                      <span
                        className="inputIcon"
                        style={{ height: 35, lineHeight: '35px' }}
                      >
                        <img src="/assets/images/imagebrowseicon.png" />
                      </span>

                      <Textbox
                        attributesInput={{
                          // Optional.
                          id: 'bulkRcfile',
                          name: 'bulkRcfile',
                          type: 'file',
                          className: 'form-control amtpopup',
                          autoComplete: 'off',
                          accept: '.xlsx',
                        }}
                        validate={this.state.validate} // Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at onece, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                        validationCallback={res => {
                          this.setState({
                            hasbulkRcfileError: res,
                            validate: false,
                          });
                        }}
                        onChange={(bulkRcfile, e) => {
                          this.setState({ bulkRcfile: e.target.files[0] });
                        }}
                        onBlur={e => {
                          console.log();
                        }}
                        validationOption={{
                          name: 'Uploaded File',
                          check: true,
                          required: true,
                          customFunc: amt => {
                            const reg = /^.+\.(xlsx)$/;
                            if (reg.test(String(amt))) {
                              return true;
                            } else {
                              return 'Enter Valid .xlsx File';
                            }
                          },
                        }}
                      />

                      {/* <input id='bulkRcfile' name='bulkRcfile' type='file' className="form-control amtpopup" autoComplete="off" accept=".xlsx" onChange={(e)=>this.changeFileValidation(e)} /> */}
                    </div>
                  </div>

                  <div className="submitRow">
                    <button
                      className="backBtn"
                      onClick={() => this.hideBulkUploadPopUpModel()}
                      type="button"
                    >
                      Cancel
                    </button>
                    <button
                      className="blueBtn"
                      type="submit"
                      disabled={this.state.isbulkUploading ? true : false}
                    >
                      Upload
                    </button>
                  </div>

                  {/* {this.state.balanceupdatedstatus === true ? <p style={{ color: "green" }}>Successfully balance add</p> : <p></p>}
                  {this.state.balanceupdatedstatus === false ? <p style={{ color: "maroon" }}>Somthing Went Wrong</p> : <p></p>} */}
                </form>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default ApiHistoryExcel;
